var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoEscapeReumSingle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 56,
    viewBox: "0 0 240 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1645_8580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49023 9.62891H21.5309V15.6643H13.8803V24.7173H20.6401V30.7526H13.8803V40.0133H21.6884V46.0486H7.49023V9.62891Z",
    fill: "url(#paint0_radial_1645_8580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2097 44.7983V38.1913C25.464 39.491 27.2456 40.2191 28.9726 40.2191C30.8057 40.2191 32.3783 39.3346 32.3783 37.0961V36.9908C32.3783 35.327 31.8541 34.0784 28.8151 30.6426C24.4671 25.7535 22.6855 23.4098 22.6855 18.9871V18.8818C22.6855 13.054 26.5093 9.35938 31.5935 9.35938C34.1599 9.35938 35.6809 9.72342 37.2534 10.5027V17.1097C35.2627 15.9664 34.0568 15.4459 32.3813 15.4459C30.5997 15.4459 29.0817 16.5892 29.0817 18.5689V18.6742C29.0817 20.3921 29.6059 21.0149 32.6449 24.5019C37.6746 30.2755 38.7744 32.5139 38.7744 36.6749V36.7802C38.7744 42.5027 34.7386 46.3026 29.7089 46.3026C27.1941 46.3026 25.0459 45.6768 23.2128 44.7952L23.2097 44.7983Z",
    fill: "url(#paint1_radial_1645_8580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3477 28.4601V27.2115C39.3477 14.4127 44.1167 9.36719 50.0887 9.36719C51.8703 9.36719 52.9187 9.57478 54.2791 10.2006V16.7564C52.9702 15.9772 51.9218 15.559 50.7159 15.559C47.886 15.559 45.8438 18.0562 45.8438 27.1603V28.5142C45.8438 38.1389 47.886 40.1156 50.822 40.1156C51.8188 40.1156 53.0762 39.7515 54.3852 38.9723V45.2152C52.9187 46.0486 51.5037 46.3074 49.6706 46.3074C43.8016 46.3074 39.3477 41.1566 39.3477 28.4631V28.4601Z",
    fill: "url(#paint2_radial_1645_8580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9289 9.52344H68.7401L75.709 46.0484H69.3158L68.1099 38.8156H62.2925L61.1411 46.0484H54.957L61.9258 9.52344H61.9289ZM67.1676 33.0932L65.2285 21.0736L63.2378 33.0932H67.1676Z",
    fill: "url(#paint3_radial_1645_8580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8594 9.62891H82.5708C89.5396 9.62891 94.4117 13.3747 94.4117 21.9072V22.0125C94.4117 30.2321 89.8002 34.1344 83.304 34.6037H83.2525V46.0486H76.8594V9.62891ZM83.304 28.7218C85.9764 28.5653 88.0186 26.6398 88.0186 22.2171V22.1118C88.0186 17.4815 86.237 15.5048 83.4616 15.5048H83.2525V28.7188H83.304V28.7218Z",
    fill: "url(#paint4_radial_1645_8580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.248 9.62891H110.289V15.6643H102.638V24.7173H109.398V30.7526H102.638V40.0133H110.446V46.0486H96.248V9.62891Z",
    fill: "url(#paint5_radial_1645_8580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.234 53.3501H0V2.72656H114.234V4.53175H1.81795V51.5449H114.234V53.3501Z",
    fill: "url(#paint6_radial_1645_8580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.23 54.0203H127.908V37.9872H128.074L131.18 49.5314H133.243L129.604 36.0105H125.917V54.0203H116.127V30.0083H114.137V56H145.221V30.0083H143.23V54.0203ZM114.137 0V25.9857H116.127V19.9082H119.954V49.6066H121.945V17.9316H116.127V1.97668H143.23V25.9857H145.221V0H114.137Z",
    fill: "url(#paint7_radial_1645_8580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.946 7.98059H130.878C134.42 7.98059 137.41 10.8659 137.41 14.2807V29.5526C137.41 32.7689 136.444 34.8899 134.459 36.0423L133.802 36.4244L137.365 49.5331H139.401L136.111 37.333C138.295 35.7534 139.401 33.1419 139.401 29.5556V14.2837C139.401 9.7948 135.499 6.00391 130.878 6.00391H119.955V12.8907H121.946V7.98059Z",
    fill: "url(#paint8_radial_1645_8580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.22 12.003H125.775V31.9895H129.996C131.402 31.9895 132.62 31.1831 133.211 30.0068C133.45 29.5314 133.587 28.9898 133.587 28.4242V14.3498C133.587 13.056 132.526 12 131.22 12V12.003ZM131.596 28.4272C131.596 29.2727 130.923 29.9646 130.084 30.0098C130.057 30.0128 130.029 30.0128 129.999 30.0128H127.769V13.9797H131.223C131.429 13.9797 131.599 14.1452 131.599 14.3528V28.4272H131.596Z",
    fill: "url(#paint9_radial_1645_8580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.685 21.6094C155.689 21.6094 154.004 23.3213 154.004 25.3461V28.9896H161.382V25.3461C161.382 23.3213 159.688 21.6094 157.685 21.6094ZM159.391 27.0129H155.995V25.3491C155.995 24.4285 156.801 23.5891 157.685 23.5891C158.57 23.5891 159.391 24.4104 159.391 25.3491V27.0129Z",
    fill: "url(#paint10_radial_1645_8580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.167 32.4116H166.774V25.7053C166.774 20.2928 162.868 16.207 157.69 16.207C152.512 16.207 148.619 20.2928 148.619 25.7053V33.4015H150.609V25.7053C150.609 21.418 153.651 18.1837 157.69 18.1837C161.729 18.1837 164.783 21.418 164.783 25.7053V32.4116H154.006V41.6211C154.006 43.5918 155.66 45.1924 157.69 45.1924C159.72 45.1924 161.387 43.5918 161.387 41.6211V38.802H159.396V41.6211C159.396 42.4846 158.614 43.2157 157.69 43.2157C156.766 43.2157 155.996 42.4846 155.996 41.6211V34.3883H170.167V54.0197H145.225V39.7918H148.606V41.0916C148.606 46.4199 152.597 50.5959 157.69 50.5959C162.783 50.5959 166.774 46.5102 166.774 41.0916V38.802H164.783V41.0916C164.783 45.3819 161.732 48.6162 157.69 48.6162C153.648 48.6162 150.597 45.3819 150.597 41.0916V37.8121H145.225V30.0047H143.234V55.9964H172.161V30.0047H170.17V32.4086L170.167 32.4116Z",
    fill: "url(#paint11_radial_1645_8580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.23 0V25.9857H145.221V1.97668H148.615V12.7807H155.996V7.38022H165.776V5.40353H154.005V10.8041H150.605V1.97668H170.166V10.8041H160.389V12.7807H170.166V25.9857H172.157V0H143.23Z",
    fill: "url(#paint12_radial_1645_8580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.102 0V25.9857H199.095V12.7807H210.791V6.39037H208.8V10.8041H199.095V1.97668H214.642V11.7939H216.635V7.38022H227.319V5.40353H216.635V1.97668H232.167V10.8041H227.319V12.7807H234.157V1.97668H238.009V25.9857H239.999V0H197.102Z",
    fill: "url(#paint13_radial_1645_8580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.009 48.621H234.158V44.2073H232.168V50.5977H238.009V54.0216H228.317V23.4055C228.317 22.4157 227.505 21.6094 226.508 21.6094H220.487V49.5778H222.478V23.5861H226.326V54.0216H216.636V23.4055C216.636 22.4157 215.824 21.6094 214.824 21.6094H208.804V49.641H210.795V23.5861H214.646V54.0216H199.096V30.0095H197.105V56.0013H240.003V30.0095H238.012V48.621H238.009Z",
    fill: "url(#paint14_radial_1645_8580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.157 38.8015V23.5808C234.157 19.3175 230.664 15.8516 226.373 15.8516H202.961V49.6357H204.952V17.8282H226.373C229.567 17.8282 232.166 20.4097 232.166 23.5808V38.8015H234.157Z",
    fill: "url(#paint15_radial_1645_8580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.166 0V25.9857H172.157V7.38022H180.943V12.7838H182.934V5.40353H172.157V1.97668H186.328V12.7807H192.712V10.8041H188.318V1.97668H197.105V16.2046H191.442V41.6517C191.442 45.4547 188.324 48.5536 184.498 48.5536C180.671 48.5536 177.547 45.4577 177.547 41.6517V12.7807H175.556V41.6548C175.556 46.5498 179.568 50.5333 184.498 50.5333C189.427 50.5333 193.436 46.5498 193.436 41.6548V18.1843H197.108V25.9857H199.099V0H170.169H170.166Z",
    fill: "url(#paint16_radial_1645_8580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.102 54.0198H172.157V30.0078H170.166V55.9995H199.096V30.0078H197.102V54.0198Z",
    fill: "url(#paint17_radial_1645_8580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.938 17.1953V41.5323C180.938 43.5511 182.592 45.1968 184.628 45.1968C186.664 45.1968 188.318 43.5541 188.318 41.5323V17.1953H186.328V41.5323C186.328 42.462 185.567 43.2171 184.631 43.2171C183.695 43.2171 182.934 42.462 182.934 41.5323V17.1953H180.944H180.938Z",
    fill: "url(#paint18_radial_1645_8580)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6083 28.1751) rotate(-25.2891) scale(32.2856 39.4307)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.7514 28.1722) rotate(-22.9253) scale(35.9156 40.7428)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8865 28.1785) rotate(-24.3453) scale(33.9346 40.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.3607 28.1233) rotate(-17.9621) scale(44.852 41.6045)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.6589 28.1751) rotate(-20.9158) scale(38.6333 40.7364)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.366 28.1751) rotate(-25.2891) scale(32.2856 39.4307)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.2693 28.5059) rotate(-4.66642) scale(235.646 60.4173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.72 28.5172) rotate(-18.3575) scale(67.3353 63.6437)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.704 28.1705) rotate(-22.4064) scale(43.246 48.188)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.691 22.1794) rotate(-25.2373) scale(17.7544 21.6513)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.703 25.3677) rotate(-10.4396) scale(15.4242 8.69101)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.736 36.4692) rotate(-14.2172) scale(61.3523 46.1858)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.732 13.2329) rotate(-9.39524) scale(60.2818 30.6987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(218.608 13.2329) rotate(-6.36645) scale(88.7448 30.9242)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(218.611 39.123) rotate(-8.40009) scale(89.1539 40.7401)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(218.601 33.0557) rotate(-11.2808) scale(65.4027 39.6726)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(184.671 25.7334) rotate(-17.8331) scale(62.488 57.6028)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(184.669 43.2437) rotate(-9.39641) scale(60.2883 30.7057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1645_8580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(184.638 31.4547) rotate(-34.9449) scale(18.513 27.4845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277585"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1645_8580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEscapeReumSingle);
export default __webpack_public_path__ + "static/media/logo-escapeReum-single.376b9b87aeea0989437436deabc3aac2.svg";
export { ForwardRef as ReactComponent };